import React, { useEffect, useState } from 'react'
import { Typography, Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FormattedMessage, useIntl } from 'react-intl'
import clsx from 'clsx'
import * as R from 'ramda'
import { htmlToPlainText } from 'libs/text'
import { voucherDateFormat } from 'commons/date'
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
  voucherSectionContainer: {
    border: 'solid 1px #d2d2d2',
    borderRadius: '11px',
    margin: '18px 10px 22px 10px',
    padding: '12px 10px 12px 18px',
    cursor: 'pointer',
  },
  textHeader: {
    color: '#404040',
  },
  chipStatusStyle: {
    height: '21px',
    marginLeft: '5px',
    margin: '5px',
    color: theme.palette.primary.text,
  },
  voucherActive: {
    backgroundColor: theme.palette.voucher.activeBadgeBg,
    color: theme.palette.voucher.activeBadgeTxt,
  },
  voucherExpired: {
    backgroundColor: theme.palette.voucher.expiredBadgeBg,
    color: theme.palette.voucher.expiredBadgeTxt,
  },
  voucherCanceled: {
    backgroundColor: theme.palette.voucher.canceledBadgeBg,
    color: theme.palette.voucher.canceledBadgeTxt,
  },
  voucherFullyRedeem: {
    backgroundColor: theme.palette.voucher.fullyRedeemBadgeBg,
    color: theme.palette.voucher.fullyRedeemBadgeTxt,
  },
}))

export const VOUCHER_STATUS = {
  1: {
    name: 'ACTIVE',
    labelId: 'notification.voucherStatus.active',
    classes: 'voucherActive',
  },
  2: {
    name: 'FULLY_REDEEM',
    labelId: 'notification.voucherStatus.fullyRedeem',
    classes: 'voucherFullyRedeem',
  },
  3: {
    name: 'CANCELED',
    labelId: 'notification.voucherStatus.canceled',
    classes: 'voucherCanceled',
  },
  4: {
    name: 'EXPIRED',
    labelId: 'notification.voucherStatus.expired',
    classes: 'voucherExpired',
  },
}

export const VoucherStatusChip = ({ voucher, ...props }) => {
  const { formatMessage } = useIntl()
  const classes = useStyles()
  const chipProps = VOUCHER_STATUS[`${voucher.status}`]
  return chipProps ? (
    <Chip
      className={clsx(classes.chipStatusStyle, classes[chipProps.classes])}
      label={formatMessage({
        id: chipProps.labelId,
      })}
    />
  ) : null
}

const AttachedVoucherSection = ({
  voucher,
  toggleVoucher,
  selectedLanguageId,
}) => {
  const classes = useStyles()
  const [translated, setTranslated] = useState({})

  useEffect(() => {
    const selectedTranslation = R.filter(
      R.propEq('languageId', selectedLanguageId),
      R.prop('translates', voucher),
    )
    setTranslated(selectedTranslation[0])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguageId])
  return (
    <div
      className={clsx('w-auto cursor-point', classes.voucherSectionContainer)}
      onClick={() => toggleVoucher(true, voucher)}
    >
      <div className="w-full">
        <Typography variant="subtitle2" className={classes.textHeader}>
          <FormattedMessage id="notificationTimeline.card.voucher.section.title" />
        </Typography>
      </div>
      <div className="w-full flex flex-row p-2">
        <div className="w-48 h-auto">
          <img
            className="max-w-full"
            alt="voucherIcon"
            src={R.pathOr('', ['template', 'imageUrl'], voucher)}
          />
        </div>
        <div className="w-auto flex flex-col ml-16">
          <div className="font-medium">
            {htmlToPlainText(R.prop('title', translated))}{' '}
            <VoucherStatusChip voucher={voucher} />
          </div>
          <Typography variant="body1" className="text-gray-500">
            <FormattedMessage
              id="notificationTimeline.card.voucher.section.validFrom"
              values={{
                startDate: moment(R.prop('startDate', voucher)).format(
                  voucherDateFormat,
                ),
                endDate: moment(R.prop('endDate', voucher)).format(
                  voucherDateFormat,
                ),
              }}
            />
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default AttachedVoucherSection
